module.exports = __webpack_public_path__ + "img/ps_common.1acdf8f8.png";